const resumeDetails = {
  firstName: "Chris",
  lastName: "McGillicuddy",
  fullName: "Chris McGillicuddy",
  positionHeadline: "Electrical Engineer & Web Developer",
  contact: [
    {
      name: "email",
      value: "cmcgill2@asu.edu"
    },
    {
      name: "location",
      value: "NYC"
    },
    {
      name: "web",
      value: "cmcgill.io"
    },
    {
      name: "github",
      value: "cmcgill2"
    }
  ],
  summary:
    "Electrical engineer and software developer with over two years of experience creating cloud applications leveraging Python and Javascript. Highly motivated individual with proven ability to design, test and publish web applications along with a desire to use new web technologies.",
  workHistory: [
    {
      title: "Python Developer",
      timeline: "July 2018 - October 2018",
      employer: "Prolific Interactive",
      responsibilities: [
        "Utilization of Flask to create a restful API with JWT authentication for CompensationIQ.com",
        "Established over 50 data models employing SQLAlchemy for ORM",
        "Created comprehensive test suite encompassing over 350 individual evaluations with PyTest",
        "Handled database migrations in a production environment leveraging Alembic"
      ]
    },
    {
      title: "Full Stack Javascript Developer",
      timeline: "August 2016 - June 2016",
      employer: "Epx Labs",
      responsibilities: [
        "Engaged in task based development for clients creating services such as authenticated API endpoints",
        "Created database entries from parsed CSV files for event management application",
        "Developed user authentication system around Google Identity platform for ad-tech application"
      ]
    }
  ],
  educationHistory: [
    {
      degree: "Electrical Engineering (B.S.)",
      completedDate: "2017",
      institution: "Arizona State University"
    }
  ],
  skills: [
    {
      name: "Python",
      rating: 7
    },
    {
      name: "Javascript",
      rating: 6
    },
    {
      name: "Vue.js",
      rating: 6
    },
    {
      name: "React",
      rating: 5
    },
    {
      name: "AWS",
      rating: 4
    },
    {
      name: "HTML",
      rating: 6
    },
    {
      name: "CSS",
      rating: 6
    },
    {
      name: "Clojure",
      rating: 3
    },
    {
      name: "Serverless",
      rating: 4
    },
    {
      name: "Unix/Linux",
      rating: 5
    },
    {
      name: "SQL",
      rating: 4
    }
  ],
  interests: ["Sports", "Gaming", "Piano"]
};

export default resumeDetails;



// WEBPACK FOOTER //
// ./src/assets/resume.js